import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import { IOwnerSettings } from '../entities/account.model';
import { AuthStore } from '@auth/data-access';

@Injectable({providedIn: 'root'})
export class AccountService {
  private http = inject(HttpClient);
  private apiUrl = inject(APP_CONFIG).apiUrl;
  private authStore = inject(AuthStore);

  public getOwnerSettings(): Observable<IOwnerSettings> {
    return this.http.get<IOwnerSettings>(`${this.apiUrl.account_service}/OwnerSettings/GetCulture`);
  }

  public getAllLogos(): Observable<IOwnerSettings['Logos']> {
    return this.http.get<IOwnerSettings['Logos']>(`${this.apiUrl.account_service}/OwnerSettings/GetLogoAsync`,
      {
      withCredentials: true,
    });
  }

  public GetLogosByTenantId(tenantId: string): Observable<IOwnerSettings['Logos']> {
    return this.http.get<IOwnerSettings['Logos']>
    (`${this.apiUrl.account_service}/OwnerSettings/GetLogosByTenantIdAsync?tenantId=${tenantId}`);
  }

  public updateOwnerSettings(payload: Partial<IOwnerSettings>): Observable<IOwnerSettings> {
    const tenantId = this.authStore.getAuthData()?.TenantId;
    return this.http.patch<IOwnerSettings>(`${this.apiUrl.account_service}/OwnerSettings`, {
      ...payload,
      OwnerSettingsId: tenantId,
    }, {
      withCredentials: true,
    });
  }
}
